import { useUI } from "providers/UIProvider"

import { Flex } from "@chakra-ui/react"
import { ILaundryAdditionalServicesProps } from "components/templates/LaundryTemplate/LaundryTemplateTypes"

import Button from "components/UI/atoms/Button"
import Heading from "components/UI/atoms/Heading"
import { StyledFlex } from "./StyledLaundryAdditionalServices"
import { IAdditionalService } from "types/laundry"

const LaundryAdditionalServices: React.FC<ILaundryAdditionalServicesProps> = ({ 
  additionalServices,
  selectedAdditionalServices,
  handleAdditionalServiceClick
}) => {
  const { T } = useUI()

  return (
    <>
      <Heading
        variant="bold"
        size={"sm"}
        title={T("loundry.add.additional.service")}
      />
      <Flex mt={"10px"} gap={"30px"}>
        {additionalServices.map((additionalService: IAdditionalService) => (
          <StyledFlex key={additionalService.id}>
            <Button
              styles={{ width: "auto", height: "50px", fontSize: "sm" }}
              leftImg={additionalService.imageUrl}
              variant={`${selectedAdditionalServices.includes(additionalService.id) ? "solid" : "outlined_dark_gray"}`}
              text={additionalService.name}
              onClick={()=>handleAdditionalServiceClick(additionalService.id)}
              className={`btn ${selectedAdditionalServices.includes(additionalService.id) ? "selected" : ""}`}
            />
          </StyledFlex>
        ))}
      </Flex>
    </>
  )
}

export default LaundryAdditionalServices
